import { TableHeader } from "app/components/Table/types";
import { getPlanningTypeIcon } from "./helper";
import { PlanningViewBy, SprintTabsEnum } from "./types";

export const HEADERS: TableHeader[] = [
  {
    name: "Name",
    id: "name",
    className: "!p-[4px] py-[12px]",
  },
  {
    name: "Epic",
    id: "epic",
    className: "!p-[4px] py-[12px]",
  },
  {
    name: "Release",
    id: "release",
    className: "!p-[4px] py-[12px]",
  },
  {
    name: "Sprint",
    id: "sprint",
    className: "!p-[4px] py-[12px]",
  },
];



export const ReleaseOptions = [
  { version: "1.0", label: "Last", color: "#E5EEFF5E" },
  { version: "2.0", label: "Current", color: "#E5EEFF5E" },
  { version: "3.0", label: "Next", color: "#E5EEFF5E" },
  { version: "4.0", label: null, color: "#E5EEFF5E" },
  { version: "5.0", label: null, color: "#E5EEFF5E" },
];

export const planningOptions = [
  {
    label: "Components",
    value: PlanningViewBy.COMPONENTS,
    icon: getPlanningTypeIcon(PlanningViewBy.COMPONENTS),
  },
  {
    label: "Epics",
    value: PlanningViewBy.EPICS,
    icon: getPlanningTypeIcon(PlanningViewBy.EPICS),
  },
  {
    label: "Stories",
    value: PlanningViewBy.STORIES,
    icon: getPlanningTypeIcon(PlanningViewBy.STORIES),
  },
  {
    label: "Sprints",
    value: PlanningViewBy.SPRINTS,
    icon: getPlanningTypeIcon(PlanningViewBy.SPRINTS),
  },
  {
    label: "Next Releases",
    value: PlanningViewBy.NEXT_RELEASES,
    icon: getPlanningTypeIcon(PlanningViewBy.NEXT_RELEASES),
  },
  {
    label: "Past Releases",
    value: PlanningViewBy.PAST_RELEASES,
    icon: getPlanningTypeIcon(PlanningViewBy.PAST_RELEASES),
  },
];

export const sprintTabs = [
  { id: SprintTabsEnum.NEXT_SPRINTS, name: "Next Sprint" },
  { id: SprintTabsEnum.PAST_SPRINTS, name: "Past Sprint" },
];
